import * as React from 'react';
import { useState } from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
// eslint-disable-next-line
export const StatusHandler = (status, type) => {
  // eslint-disable-next-line
  switch (status) {
    case 'DONE':
      return (
        <Typography
          sx={{
            display: 'block',
            alignItems: 'center',
            textAlign: 'center',
            border: 'none',
            fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
            borderRadius: '8px',
            p: '8px',
            background: '#D4ECCF',
            maxWidth: '200px',
            m: '0 auto'
          }}
        >
          {/*<CheckCircleOutlineOutlinedIcon sx={{ mr: 2, color: '#60A5DF' }} />*/}
          Виконано
        </Typography>
      );
    case 'NEW':
      if (type === 'history') {
        return (
          <Typography
            sx={{
              display: 'block',
              alignItems: 'center',
              textAlign: 'center',
              border: 'none',
              fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
              borderRadius: '8px',
              p: '8px',
              background: '#E2F2FF',
              maxWidth: '200px',
              m: '0 auto'
            }}
          >
            {/*<HourglassEmptyOutlinedIcon sx={{ mr: 2, color: '#5CB85C' }} />*/}
            Необроблене
          </Typography>
        );
      } else {
        return (
          <Typography
            sx={{
              display: 'block',
              alignItems: 'center',
              textAlign: 'center',
              border: 'none',
              fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
              borderRadius: '8px',
              p: '8px',
              background: '#E2F2FF',
              maxWidth: '200px',
              m: '0 auto'
            }}
          >
            {/*<FiberNewOutlinedIcon sx={{ mr: 2, color: '#5CB85C' }} />*/}
            Нове
          </Typography>
        );
      }
    case 'SENT':
      return (
        <Typography
          sx={{
            display: 'block',
            alignItems: 'center',
            textAlign: 'center',
            border: 'none',
            fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
            borderRadius: '8px',
            p: '8px',
            background: '#FCF4D7',
            maxWidth: '200px',
            m: '0 auto'
          }}
        >
          {/*<AirportShuttleOutlinedIcon sx={{ mr: 2, color: '#663A8C' }} /> */}
          Відправлено
        </Typography>
      );
    case 'CANCELED':
      return (
        <Typography
          sx={{
            display: 'block',
            alignItems: 'center',
            textAlign: 'center',
            border: 'none',
            fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
            borderRadius: '8px',
            p: '8px',
            background: '#FFE5E5',
            maxWidth: '200px',
            m: '0 auto'
          }}
        >
          {/*<CancelOutlinedIcon sx={{ mr: 2, color: '#DF6060' }} />*/}
          Скасовано
        </Typography>
      );
    case 'PROCESSING':
      return (
        <Typography
          sx={{
            display: 'block',
            alignItems: 'center',
            textAlign: 'center',
            border: 'none',
            fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
            borderRadius: '8px',
            p: '8px',
            background: '#F5F4F4',
            maxWidth: '200px',
            m: '0 auto'
          }}
        >
          {/*<AccessTimeOutlinedIcon sx={{ mr: 2, color: '#FDC940' }} />*/}В обробці
        </Typography>
      );
  }
}; // eslint-disable-next-line
export const StatusHandlerSeller = (status, handler) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const menu = (
    <Menu
      anchorEl={anchorEl}
      id="action-menu"
      open={open}
      onClose={handleClose}
      onMouseLeave={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'hidden',
          boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
          borderRadius: '5px',
          border: 'none',
          paddingTop: '10px',
          paddingLeft: '20px',
          paddingRight: '20px',
          width: '200px',
          mt: 1
        }
      }}
      autoFocus={false}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {/* <MenuItem
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          handleClose();
          handler('NEW');
        }}
        sx={{ padding: 0, mb: 1 }}
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',

            p: '8px',

            cursor: 'pointer'
          }}
        >
          <FiberNewOutlinedIcon sx={{ mr: 2, color: '#5CB85C' }} /> Нове
        </Typography>
      </MenuItem> */}
      {status !== 'PROCESSING' &&
        status !== 'SENT' &&
        status !== 'DONE' &&
        status !== 'CANCELED' && (
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              handleClose();
              handler('PROCESSING');
            }}
            sx={{ padding: 0, mb: 1 }}
          >
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                p: '8px',
                cursor: 'pointer'
              }}
            >
              {/*<AccessTimeOutlinedIcon sx={{ mr: 2, color: '#FDC940' }} /> */}В обробці
            </Typography>
          </MenuItem>
        )}
      {status !== 'SENT' && status !== 'DONE' && status !== 'CANCELED' && (
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            handleClose();
            handler('SENT');
          }}
          sx={{ padding: 0, mb: 1 }}
        >
          <Typography
            sx={{
              display: 'flex',
              alignItems: 'center',
              p: '8px',
              cursor: 'pointer'
            }}
          >
            {/*<AirportShuttleOutlinedIcon sx={{ mr: 2, color: '#663A8C' }} />*/}
            Відправлено
          </Typography>
        </MenuItem>
      )}

      <MenuItem
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          handleClose();
          handler('DONE');
        }}
        sx={{ padding: 0, mb: 1 }}
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            p: '8px',
            cursor: 'pointer'
          }}
        >
          {/*<CheckCircleOutlineOutlinedIcon sx={{ mr: 2, color: '#60A5DF' }} />*/}
          Отримано
        </Typography>
      </MenuItem>
      {/* {status !== 'SENT' && ( */}
      <MenuItem
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          handleClose();
          handler('CANCELED');
        }}
        sx={{ padding: 0, mb: 1 }}
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            p: '8px',
            cursor: 'pointer'
          }}
        >
          {/*<CancelOutlinedIcon sx={{ mr: 2, color: '#DF6060' }} />*/}
          Скасовано
        </Typography>
      </MenuItem>
      {/* )} */}
    </Menu>
  );
  // eslint-disable-next-line
  const renderStatus = (status) => {
    // eslint-disable-next-line
    switch (status) {
      case 'DONE':
        return (
          <>
            <Typography
              sx={{
                fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
                display: 'block',
                alignItems: 'center',
                textAlign: 'center',
                border: 'none',
                borderRadius: '8px',
                p: '8px',
                background: '#E8F4FF',
                maxWidth: '200px',
                m: '0 auto'
              }}
              // onClick={handleClick}
            >
              {/*<CheckCircleOutlineOutlinedIcon sx={{ mr: 2, color: '#60A5DF' }} />*/}
              Отримано
              {/* <ArrowDropDownOutlinedIcon sx={{ color: '#60A5DF', margin: '0px 0px 0px auto' }} /> */}
            </Typography>
          </>
        );
      case 'NEW':
        return (
          <>
            {' '}
            <Typography
              sx={{
                fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
                display: 'flex',
                justifyContent: 'space-between',
                gap: '8px',
                alignItems: 'center',
                textAlign: 'center',
                border: 'none',
                borderRadius: '8px',
                p: '8px',
                background: '#E2F2FF',
                cursor: 'pointer',
                maxWidth: '200px',
                m: '0 auto'
              }}
              onClick={handleClick}
            >
              {/*<FiberNewOutlinedIcon sx={{ mr: 2, color: '#5CB85C' }} />*/}
              Нове
              <ArrowDropDownOutlinedIcon sx={{ color: '#60A5DF', margin: '0px 0px 0px auto' }} />
            </Typography>
            {menu}
          </>
        );
      case 'SENT':
        return (
          <>
            <Typography
              sx={{
                fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
                display: 'flex',
                gap: '8px',
                justifyContent: 'space-between',
                alignItems: 'center',
                textAlign: 'center',
                border: 'none',
                borderRadius: '8px',
                p: '8px',
                background: '#FCF4D7',
                cursor: 'pointer',
                maxWidth: '200px',
                m: '0 auto'
              }}
              onClick={handleClick}
            >
              {/*<AirportShuttleOutlinedIcon sx={{ mr: 2, color: '#663A8C' }} />*/}
              Відправлено
              <ArrowDropDownOutlinedIcon sx={{ color: '#EFC938', margin: '0px 0px 0px auto' }} />
            </Typography>
            {menu}
          </>
        );
      case 'CANCELED':
        return (
          <>
            <Typography
              sx={{
                fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
                display: 'flex',
                gap: '8px',
                justifyContent: 'space-between',
                alignItems: 'center',
                textAlign: 'center',
                border: 'none',
                borderRadius: '8px',
                p: '8px',
                background: '#FFE5E5',
                maxWidth: '200px',
                m: '0 auto'
              }}
              // onClick={handleClick}
            >
              {/*<CancelOutlinedIcon sx={{ mr: 2, color: '#DF6060' }} />*/}
              Скасовано
              {/*<ArrowDropDownOutlinedIcon sx={{ color: '#F64D36', margin: '0px 0px 0px auto' }} />*/}
            </Typography>
          </>
        );
      case 'PROCESSING':
        return (
          <>
            <Typography
              sx={{
                fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
                display: 'flex',
                gap: '8px',
                justifyContent: 'space-between',
                alignItems: 'center',
                textAlign: 'center',
                border: 'none',
                borderRadius: '8px',
                p: '8px',
                background: '#F5F4F4',
                cursor: 'pointer',
                maxWidth: '200px',
                m: '0 auto'
              }}
              onClick={handleClick}
            >
              {/*<AccessTimeOutlinedIcon sx={{ mr: 2, color: '#FDC940' }} />*/}В обробці
              <ArrowDropDownOutlinedIcon sx={{ color: '#7C7C7C', margin: '0px 0px 0px auto' }} />
            </Typography>
            {menu}
          </>
        );
    }
  };
  return <>{renderStatus(status)}</>;
};
